import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const CircleCloseGlyph = /*#__PURE__*/createElement("g", {
  id: "circle_close",
  style: {
    transform: 'translate(-5px, -3px) scale(0.7)'
  }
}, /*#__PURE__*/createElement("path", {
  d: "M113.438 66C113.438 78.7875 108.488 90.75 99.4125 99.825C90.3375 108.9 78.375 113.438 66 113.438C39.6 113.025 18.5625 91.1625 18.5625 64.7625C18.5625 39.6 38.775 18.975 63.9375 18.5625C64.7625 18.5625 65.175 18.5625 66 18.5625C78.375 18.5625 90.75 23.5125 99.4125 32.175C108.488 41.25 113.438 53.2125 113.438 66Z",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/createElement("path", {
  d: "M47.4375 47.4375L84.5625 84.5625M84.5625 47.4375L47.4375 84.5625",
  strokeWidth: "2",
  strokeLinecap: "round"
}));
const CircleClose = createSvg({
  name: 'circle_close',
  path: CircleCloseGlyph
});

export default CircleClose;
export { CircleCloseGlyph };
